import React from 'react';
import styles from './ConfirmModal.module.scss';
import Close from '@src/assets/Close.png';

type ConfirmModalProps = {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}


const ConfirmModal: React.FC<ConfirmModalProps> = ({ isOpen, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <button className={styles.closeButton} onClick={onCancel} aria-label="Close">
                    <img src={Close} alt="Close" width={14} height={14} />
                </button>
                <p className={styles.modalText}>Voulez-vous vraiment supprimer ce fichier ?</p>
                <div className={styles.actions}>
                    <button className={styles.button} onClick={onConfirm}>
                        Oui
                    </button>
                    <button className={styles.button} onClick={onCancel}>
                        Non
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
